module.exports = __webpack_public_path__ + "components/flag/static/square/ro-f53abffeab4b0ea8dc2bf67b820dc99c.svg";